<template>
  <div class="aa-tool">
    <div class="aa-input-section">
      <div class="aa-input-label">
        <span class="aa-dot" />
        {{ $t('tool.AsciiArt.title') }}
      </div>

      <el-tabs v-model="mode" @tab-click="reset" class="aa-tabs">
        <!-- Text mode -->
        <el-tab-pane :label="$t('tool.AsciiArt.textToAscii')" name="text">
          <div class="aa-text-area">
            <el-input
              v-model="textInput" type="textarea" :rows="3"
              placeholder="输入文字内容，如 HELLO"
              class="aa-textarea" @input="genText"
            />
            <div class="aa-font-bar">
              <span class="aa-font-label">{{ $t('tool.AsciiArt.font') }}</span>
              <el-radio-group v-model="font" size="small" @change="genText">
                <el-radio-button label="doom">Doom</el-radio-button>
                <el-radio-button label="standard">Standard</el-radio-button>
                <el-radio-button label="small">Small</el-radio-button>
              </el-radio-group>
            </div>
          </div>
        </el-tab-pane>

        <!-- Image mode -->
        <el-tab-pane :label="$t('tool.AsciiArt.imgToAscii')" name="image">
          <div class="aa-image-area">
            <div class="aa-upload-zone">
              <el-upload
                drag action="#" :auto-upload="false" :show-file-list="false"
                :on-change="handleImage" accept="image/png,image/jpeg,image/webp"
              >
                <i class="el-icon-upload" />
                <div class="el-upload__text">{{ $t('tool.AsciiArt.dropText') }}<em>{{ $t('tool.AsciiArt.clickUpload') }}</em></div>
                <div class="el-upload__tip">{{ $t('tool.AsciiArt.uploadHint') }}</div>
              </el-upload>
            </div>
            <div class="aa-img-controls" v-if="imageSrc">
              <div class="aa-img-preview">
                <img :src="imageSrc" alt="preview" />
              </div>
              <div class="aa-img-settings">
                <div class="aa-field">
                  <label>{{ $t('tool.AsciiArt.width') }}（{{ imgWidth }}）</label>
                  <el-slider v-model="imgWidth" :min="20" :max="200" :step="10" @change="genImage" />
                </div>
                <div class="aa-field">
                  <label>{{ $t('tool.AsciiArt.charset') }}</label>
                  <el-select v-model="charset" size="small" @change="genImage">
                    <el-option :label="$t('tool.AsciiArt.charsetStandard')" value="@%#*+=-:. " />
                    <el-option :label="$t('tool.AsciiArt.charsetSimple')" value="#. " />
                    <el-option label="密集 $" value="$@B%8&amp;WM#*oahkbdpqwmZO0QLCJUYXzcvunxrjft/\\|()1{}[]?-_+~i!lI;:&quot;^. " />
                  </el-select>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <!-- Output -->
    <div class="aa-output" v-if="output">
      <div class="aa-output-bar">
        <span class="aa-bar-title">{{ $t('tool.AsciiArt.outputPreview') }}</span>
        <span class="aa-bar-meta" v-if="meta">{{ meta }}</span>
        <el-button size="mini" plain icon="el-icon-document-copy" @click="copyOutput">{{ $t("common.action.copy") }}</el-button>
      </div>
      <pre class="aa-pre">{{ output }}</pre>
    </div>

    <div class="aa-empty" v-else>{{ mode === 'image' ? $t('tool.AsciiArt.emptyImage') : $t('tool.AsciiArt.emptyText') }}</div>
  </div>
</template>

<script>
var FONT = {
  doom:{
    'A':[' ██╗ ','█╔╝ ','╚═╝  '],'B':['██╗ ','██╗ ','╚═╝ '],'C':[' ██╗','█╔╝ ','╚═╝ '],
    'D':['██╗ ','██║ ','╚═╝ '],'E':['██╗ ','██║ ','╚═╝ '],'F':['██╗ ','██║ ','╚═╝ '],
    'G':[' ██╗','█╔╝ ','╚█╝ '],'H':['█╗█╗','██╔╝','╚═╝ '],'I':['██╗','╚█║','╚═╝'],
    'J':[' ██╗','╚█║','╚═╝'],'K':['█╗█╗','██╔╝','╚═╝ '],'L':['█╗  ','██╗ ','╚═╝ '],
    'M':['█╗█╗','█║█║','╚╝╚╝'],'N':['█╗█╗','██╔╝','╚═╝ '],'O':[' ██╗','█╔╝ ','╚═╝ '],
    'P':['██╗ ','██║ ','╚═╝ '],'Q':[' ██╗','█╔╝ ','╚█╗'],'R':['██╗ ','██║ ','╚═╝ '],
    'S':[' ██╗','╚█╗','██╔╝','╚═╝ '],'T':['████╗','╚╚█║','╚═╝ '],'U':['█╗█╗','╚█╔╝','╚═╝ '],
    'V':['█╗█╗','██╔╝','╚╝  '],'W':['█╗█╗█╗','█║█║█║','╚╝╚╝╚╝'],'X':['█╗╔█╗','██╔╝ ','╚═╝  '],
    'Y':['█╗╔█╗','╚█╔╝ ','╚═╝  '],'Z':['███╗','╚██╗','██╔╝','╚═╝ '],
    '0':[' ██╗','██╔╝','╚█╗ ','╚═╝ '],'1':['██╗','╚█║','╚═╝'],'2':[' ██╗','╚█╗','██╔╝','╚═╝ '],
    '3':['███╗','╚██╗','██╔╝','╚═╝ '],'4':['█╗█╗','╚█╔╝','╚═╝ '],'5':['███╗','╚██╗','██╔╝','╚═╝ '],
    '6':[' ██╗','██╔╝','██╔╝','╚═╝ '],'7':['███╗','╚█╔╝','╚═╝ '],'8':[' ██╗','██╔╝','██╔╝','╚═╝ '],
    '9':[' ██╗','██╔╝','╚█╗ ','╚═╝ '],'!':['██╗','╚═╝','██╗','╚═╝'],'?':[' ██╗','╚█╗','╚═╝','██╗'],' ':[]
  },
  standard:{
    'A':[' █████╗ ','██╔══██╗','███████║','██╔══██║','██║  ██║','╚═╝  ╚═╝'],
    'B':['██████╗ ','██╔══██╗','██████╔╝','██╔══██╗','██████╔╝','╚═════╝ '],
    'C':[' ██████╗','██╔════╝','██║     ','██║     ','╚██████╗',' ╚═════╝'],
    'D':['██████╗ ','██╔══██╗','██║  ██║','██║  ██║','██████╔╝','╚═════╝ '],
    'E':['███████╗','██╔════╝','██████╗ ','██╔═══╝ ','███████╗','╚══════╝'],
    'F':['███████╗','██╔════╝','█████╗  ','██╔══╝  ','██║     ','╚═╝     '],
    'G':['  ██████╗',' ██╔════╝',' ██║  ███╗',' ██║   ██║',' ╚██████╔╝','  ╚═════╝ '],
    'H':['██╗  ██╗','██║  ██║','███████║','██╔══██║','██║  ██║','╚═╝  ╚═╝'],
    'I':['██╗','██║','██║','██║','██║','╚═╝'],
    'J':['  ██████╗','  ╚════██╗',' █████╔╝',' ██╔═══╝ ',' ╚██████╗','  ╚═════╝'],
    'K':['██╗  ██╗','██║ ██╔╝','█████╔╝ ','██╔═██╗ ','██║  ██╗','╚═╝  ╚═╝'],
    'L':['██╗     ','██║     ','██║     ','██║     ','███████╗','╚══════╝'],
    'M':['███╗   ███╗','████╗ ████║','██╔████╔██║','██║╚██╔╝██║','██║ ╚═╝ ██║','╚═╝     ╚═╝'],
    'N':['███╗   ██╗','████╗  ██║','██╔██╗ ██║','██║╚██╗██║','██║ ╚████║','╚═╝  ╚═══╝'],
    'O':[' ██████╗ ','██╔═══██╗','██║   ██║','██║   ██║','╚██████╔╝',' ╚═════╝ '],
    'P':['██████╗ ','██╔══██╗','██████╔╝','██╔═══╝ ','██║     ','╚═╝     '],
    'Q':['  ██████╗ ',' ██╔═══██╗',' ██║   ██║',' ██║▄▄ ██║',' ╚██████╔╝','  ╚══▀▀═╝ '],
    'R':['██████╗ ','██╔══██╗','██████╔╝','██╔═██╗ ','██║  ██╗','╚═╝  ╚═╝'],
    'S':['███████╗','██╔════╝','███████╗','╚════██║','███████║','╚══════╝'],
    'T':['████████╗','╚══██╔══╝','   ██║   ','   ██║   ','   ██║   ','   ╚═╝   '],
    'U':['██╗   ██╗','██║   ██║','██║   ██║','██║   ██║','╚██████╔╝',' ╚═════╝ '],
    'V':['██╗   ██╗','██║   ██║',' ██║ ██╔╝',' ╚████╔╝ ','  ╚═══╝  '],
    'W':[' ██╗    ██╗',' ██║    ██║',' ██║ █╗ ██║',' ██║███╗██║',' ╚███╔███╔╝','  ╚══╝╚══╝ '],
    'X':['██╗  ██╗','╚██╗██╔╝',' ╚███╔╝ ',' ██╔██╗ ','██╔╝ ██╗','╚═╝  ╚═╝'],
    'Y':['██╗   ██╗','╚██╗ ██╔╝',' ╚████╔╝ ','  ╚██╔╝  ','   ██║   ','   ╚═╝   '],
    'Z':['███████╗','╚══███╔╝','  ███╔╝ ',' ███╔╝  ','███████╗','╚══════╝'],' ':[]
  },
  small:{
    'A':['  /\\  ',' /  \\ ','/ __ \\','/_/ \\_\\'],'B':[' ___ ','/ _ \\','| |_||','\\___/'],
    'C':[' __ ','/ _|','\\ \\ ','/ _|','\\__|'],'D':[' __  ','/ _\\ ','| || |','\\___/'],
    'E':[' ___ ','/ _ \\','|  __/','\\___|'],'F':[' ___ ','/ _ \\','|  _/','| |  ','|_|  '],
    'G':[' __ ','/ _|','| |_ ','\\__|'],'H':[' _  _ ','| || |','| __ |','|_||_|'],
    'I':[' ___ ','|_ _|',' | | ',' |_| ','     '],'J':[' __ ','/ / ','| |_ ','\\__|'],
    'K':[' _  __','| |/ /','|  < ','|_|\\_\\'],'L':[' _   ','| |  ','| |__','|____'],
    'M':[' _   _ ','| \\ / |','| |\\/| |','|_|  |_|'],'N':[' _   _ ','| \\ | |','| |\\| |','|_| \\_|'],
    'O':['  __  ',' / _\\ ','| |_| ',' \\___/'],'P':[' ___ ','/ _ \\','| |_/','| |  ','|_|  '],
    'Q':['  __  ',' / _\\ ','| |_| ',' \\__/\\'],'R':[' ___ ','/ _ \\','| |_/','| |\\ \\','|_| \\_\\'],
    'S':[' __ ','/ _\\','\\ \\_/','\\___/'],'T':[' ____ ','|_  _|','  ||  ','  ||  ','  ||  '],
    'U':[' _   _ ','| | | |','| |_| |',' \\___/'],'V':[' _    _ ','| |  / /','| |_/ / ',' \\___/  '],
    'W':[' _      _ ','| | /| / |','| |/ |/| |','|__/|__|_|'],'X':[' __  __',' \\ \\/ /',' /\\  \\','/_/  \\_\\'],
    'Y':['__   __','\\ \\ / /',' \\ V / ','  \\_/  '],'Z':[' ___ ','/ _ \\','\\_/\\_/','\\___/'],' ':[]
  }
}

function buildBanner(text, font, space) {
  if (!text) return ''
  var chars = text.toUpperCase().split('')
  var maxH = 0, glyphs = []
  for (var i = 0; i < chars.length; i++) {
    var g = (font[chars[i]] || []).slice()
    if (g.length > maxH) maxH = g.length
    glyphs.push(g)
  }
  for (var j = 0; j < glyphs.length; j++) {
    var gl = glyphs[j]
    while (gl.length < maxH) gl.push(' '.repeat(gl[0] ? gl[0].length : 4))
  }
  var lines = []
  for (var r = 0; r < maxH; r++) {
    var line = ''
    for (var k = 0; k < glyphs.length; k++) line += (glyphs[k][r] || ' '.repeat(space))
    lines.push(line)
  }
  return lines.join('\n')
}

function imageToAscii(img, w, charset) {
  var canvas = document.createElement('canvas')
  var ratio = img.height / img.width
  var cw = w, ch = Math.floor(cw * ratio * 0.45)
  canvas.width = cw; canvas.height = ch
  var ctx = canvas.getContext('2d')
  ctx.drawImage(img, 0, 0, cw, ch)
  var data = ctx.getImageData(0, 0, cw, ch).data, result = ''
  for (var y = 0; y < ch; y++) {
    for (var x = 0; x < cw; x++) {
      var idx = (y * cw + x) * 4
      var gray = 0.299 * data[idx] + 0.587 * data[idx+1] + 0.114 * data[idx+2]
      result += charset[Math.min(Math.floor(gray / 256 * charset.length), charset.length - 1)]
    }
    result += '\n'
  }
  return result
}

export default {
  name:'AsciiArtTool',
  props:{ config:{ type:Object, default:function(){ return {} } } },
  data:function(){
    return {
      mode:'text', textInput:'HELLO', font:'doom', output:'',
      imageSrc:'', imgWidth:80, charset:'@%#*+=-:. '
    }
  },
  computed:{
    meta:function(){
      if (!this.output) return ''
      var lines = this.output.split('\n')
      return this.$t('tool.AsciiArt.metaChars', { w: lines[0].length, h: lines.length })
    }
  },
  created:function(){ this.genText() },
  methods:{
    genText:function(){
      var f = FONT[this.font]
      if (!this.textInput.trim()) { this.output = ''; return }
      this.output = buildBanner(this.textInput, f, 6)
    },
    handleImage:function(file){
      var self = this
      var reader = new FileReader()
      reader.onload = function(e){
        self.imageSrc = e.target.result
        var img = new Image()
        img.onload = function(){ self.output = imageToAscii(img, self.imgWidth, self.charset) }
        img.src = e.target.result
      }
      reader.readAsDataURL(file.raw)
    },
    genImage:function(){
      if (!this.imageSrc) return
      var self = this
      var img = new Image()
      img.onload = function(){ self.output = imageToAscii(img, self.imgWidth, self.charset) }
      img.src = this.imageSrc
    },
    reset:function(tab){
      if (tab.name === 'text') this.genText()
    },
    copyOutput:function(){
      navigator.clipboard.writeText(this.output); this.$message.success(this.$t('tool.AsciiArt.copied'))
    },
    doAction:function(a){
      if (a === 'copy') this.copyOutput()
      if (a === 'clear') { this.textInput = ''; this.imageSrc = ''; this.output = '' }
    }
  }
}
</script>

<style scoped>
.aa-tool { width: 100%; }

/* input */
.aa-input-section { margin-bottom: 20px; }
.aa-input-label { display: flex; align-items: center; gap: 8px; font-size: 14px; color: #606266; margin-bottom: 12px; }
.aa-dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; background: #4e7cff; box-shadow: 0 0 6px rgba(78,124,255,.4); }

.aa-tabs >>> .el-tabs__content { padding: 16px 0 0; }

/* text mode */
.aa-text-area { display: flex; flex-direction: column; gap: 12px; }
.aa-textarea >>> textarea { font-family: 'Courier New', monospace !important; font-size: 16px !important; letter-spacing: 2px; }
.aa-font-bar { display: flex; align-items: center; gap: 12px; }
.aa-font-label { font-size: 12px; font-weight: 600; color: #909399; flex-shrink: 0; }

/* image mode */
.aa-image-area { display: flex; flex-direction: column; gap: 16px; }
.aa-upload-zone >>> .el-upload-dragger { padding: 30px 20px; display: flex; flex-direction: column; align-items: center; justify-content: center; min-height: 140px; }
.aa-img-controls { display: flex; gap: 20px; align-items: flex-start; }
.aa-img-preview { flex-shrink: 0; width: 120px; height: 120px; border: 1px solid #ebeef5; border-radius: 8px; overflow: hidden; display: flex; align-items: center; justify-content: center; background: #fafbfc; }
.aa-img-preview img { max-width: 100%; max-height: 100%; object-fit: contain; }
.aa-img-settings { flex: 1; display: flex; flex-direction: column; gap: 14px; }
.aa-field { display: flex; flex-direction: column; gap: 6px; }
.aa-field label { font-size: 12px; font-weight: 600; color: #909399; }

/* output */
.aa-output { background: #1e1e2e; border-radius: 10px; overflow: hidden; }
.aa-output-bar { display: flex; align-items: center; gap: 10px; padding: 10px 16px; background: #2a2a3c; }
.aa-bar-title { font-size: 12px; font-weight: 600; color: #a0a0b8; }
.aa-bar-meta { font-size: 11px; color: #6a6a7c; margin-right: auto; }
.aa-pre { margin: 0; padding: 16px; font-family: 'Courier New', monospace; font-size: 11px; line-height: 1.15; color: #c9d1d9; overflow: auto; max-height: 500px; white-space: pre; background: #1e1e2e; user-select: all; }

.aa-empty { text-align: center; padding: 60px 20px; color: #c0c4cc; font-size: 14px; }

@media (max-width: 640px) {
  .aa-img-controls { flex-direction: column; }
  .aa-img-preview { width: 100%; height: 160px; }
}
</style>
